<template>
  <div class="employees responsive-menu">
    <div class="responsive-menu__child">
      <PageHeader
        :pageHeader="listPageHeader"
        :links="[
          { name: 'home', label: 'Home' },
          { name: 'employees', label: 'Employees' },
        ]"
        :entity="entity"
      />
      <SearchTable :entity="entity" :sort="sort" @sortChangeEvent="updateSort"
        :pagination="pagination" @paginationChange="updatePagination" @initialFilterUpdate="updateInitialFilter"
        :initialFilter="initialFilter"/>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import Entities from "@/resources/Entities";
import SearchTable from "@/components/SearchTable.vue";

import { filterCriteria, columnHeaders, listPageHeader } from "./inputs";

export default {
  name: "employees",
  data() {
    return {
      moment: moment,
      filterCriteria,
      selectedFilter: {},
      Entities,
      entity: Entities.EMPLOYEE,
      columnHeaders,
      listPageHeader,
    };
  },
  components: {
    PageHeader,
    SearchTable,
  },
  created: function () {
    this.setPageTitle("Employees");
  },
  computed: {
    ...mapGetters({
      loadingStatus: "employeeModule/loadingStatus",
      sort: "employeeModule/sort",
      pagination: "employeeModule/pagination",
      initialFilter: "employeeModule/initialFilter"
    }),
  },
  methods: {
    ...mapActions({
      updateSort: "employeeModule/updateSort",
      updatePagination: "employeeModule/updatePagination",
      updateInitialFilter: "employeeModule/updateInitialFilter"
    }),
  }
};
</script>
